



































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ItemDTO, FilterDTO, FilterDTOTypeEnum } from '@/api';
import {
  clientsModule, thingsModule,
} from '@/store';
import services from '@/services';
import { Form } from 'element-ui';
import IconInfo from '@/assets/icons/info.svg';
import ThingInfo from '@/components/things/ThingInfo.vue';
import ZoomOnHover from '@/components/common/ZoomOnHover.vue';
import BackgroundClipping from '../BackgroundClipping.vue';
import ThingTemperatureInput from './ThingTemperatureInput.vue';
import ThingEdit from './ThingEdit.vue';

interface IForm {
  thingId?: number;
  name?: string;
  temperatureFrom?: number;
  temperatureTo?: number;
  categoryId?: string;
}

function cloneForm(thing?: ItemDTO):IForm {
  if (thing) {
    return {
      thingId: thing.id,
      name: thing.name,
      temperatureFrom: Number(thing.temperatureFrom),
      temperatureTo: Number(thing.temperatureTo),
      categoryId: String(thing.categoryDTO?.id),
    };
  }
  return {
    name: '',
    temperatureFrom: 0,
    temperatureTo: 5,
  };
}

@Component({
  name: 'thing-options',
  components: {
    BackgroundClipping,
    IconInfo,
    ThingInfo,
    ThingEdit,
    ZoomOnHover,
    ThingTemperatureInput,
  },
})
export default class Clients extends Vue {
  form: IForm = cloneForm(this.item);

  categories: FilterDTO[] = [];

  temperatureTriggered = false;

  categoriesTriggered = false;

  inputTriggered = false;

  get client() {
    return clientsModule.model;
  }

  async created() {
    if (this.client && this.client.id != null) {
      const { data } = await services.catalogService()
        .catalogEndpointGetClientCategoryNames(this.client.id);
      this.categories = data;
    }
  }

  get multi() {
    return thingsModule.multi;
  }

  get temperature() {
    const { temperatureFrom, temperatureTo } = this.form;
    return [temperatureFrom, temperatureTo];
  }

  set temperature(value) {
    this.temperatureTriggered = true;
    [this.form.temperatureFrom, this.form.temperatureTo] = [value[0], value[1]];
  }

  get item() {
    return thingsModule.selectedThings && thingsModule.selectedThings.length
      ? thingsModule.selectedThings[0]
      : undefined;
  }

  get img() {
    return this.item && this.item.fileNames && this.item.fileNames.length
      ? this.item.fileNames[0].fileName
      : null;
  }

  get mergedCategories() {
    const mappedCategories: FilterDTO[] = thingsModule.categories
      .map(c => ({ name: String(c), id: String(c), type: FilterDTOTypeEnum.CATEGORY }));
    return [...this.categories, ...mappedCategories]
      .reduce<FilterDTO[]>((acc, curr) => (acc.findIndex(a => a.id === curr.id) > -1
        ? acc
        : acc.concat(curr)), []);
  }

  get selectedThings() {
    return thingsModule.selected;
  }

  commandHandler(count: number) {
    this.aiThings(count);
  }

  aiThings(amount = 1) {
    const ids = this.selectedThings;
    this.$router.push({
      name: 'ai-thing-catalog-things',
      query: { ids: ids.map(id => String(id)), amount: String(amount) },
    });
  }

  selectCategory(value: number) {
    this.categoriesTriggered = true;
    this.form.categoryId = String(value);
  }

  @Watch('item')
  syncForm(newValue: ItemDTO) {
    this.form = cloneForm(newValue);
    this.temperatureTriggered = false;
    this.categoriesTriggered = false;
    this.inputTriggered = false;
  }

  remove() {
    this.$confirm(`Вы уверены, что хотите удалить ${thingsModule.selected.length > 1
      ? 'данные вещи'
      : 'данную вещь'}?`, 'Внимание!',
    {
      confirmButtonText: 'Удалить',
      cancelButtonText: 'Отмена',
      type: 'warning',
    }).then(() => {
      thingsModule.deleteThing(thingsModule.selected);
      this.$message({
        type: 'success',
        message: thingsModule.selected.length > 1 ? 'Вещи удалёны' : 'Вещь удалёна',
      });
    });
  }

  reset() {
    this.temperatureTriggered = false;
    this.categoriesTriggered = false;
    this.inputTriggered = false;
    this.form = cloneForm(this.item);
  }

  resetSelect() {
    this.temperatureTriggered = false;
    this.categoriesTriggered = false;
    this.inputTriggered = false;
    thingsModule.resetSelect();
  }

  onSubmit() {
    (this.$refs.form as Form).validate((valid) => {
      if (valid && this.form.categoryId && clientsModule?.model?.id != null) {
        if (this.multi) {
          const things = thingsModule.list
            .filter(thing => thing.id && thingsModule.selected.includes(thing.id))
            .map(thing => ({
              thingId: thing.id,
              userId: clientsModule.model?.id as number,
              // eslint-disable-next-line max-len
              categoryId: Number(this.categoriesTriggered ? this.form.categoryId : thing.categoryDTO?.id),
              name: thing.name,
              comments: thing.comments,
              size: thing.size,
              ...(this.temperatureTriggered ? {
                temperatureFrom: this.form.temperatureFrom,
                temperatureTo: this.form.temperatureTo,
              } : {
                temperatureFrom: thing.temperatureFrom,
                temperatureTo: thing.temperatureTo,
              }),
            }));
          thingsModule.saveThings(things);
        } else {
          thingsModule.saveThings([{
            ...this.form,
            categoryId: Number(this.form.categoryId),
            userId: clientsModule.model.id,
          }]);
        }
        this.resetSelect();
        return false;
      }
      // console.log('error submit!!');
      return false;
    });
  }

  openInfo() {
    if (this.item && this.item.catalogItemId != null) {
      (this.$refs.thingInfo as ThingInfo).open(this.item.catalogItemId);
    }
  }

  openThingEdit() {
    if (this.item && this.item.id != null) {
      (this.$refs.thingEdit as ThingEdit).open(this.item.id);
    }
  }

  async improveImage(imageUrl: string) {
    if (this.form.categoryId != null && clientsModule?.model?.id != null) {
      thingsModule.saveThings([{
        ...this.form,
        categoryId: Number(this.form.categoryId),
        imageUrl,
        userId: clientsModule.model.id,
      }]);
    }
  }

  triggerInput() {
    this.inputTriggered = true;
  }

  goClients() {
    if (this.client && this.client.id != null && this.item && this.item.id != null) {
      this.$router.push({
        name: 'ai-looks-by-client-thing-from-clients-things',
        params: { clientId: String(this.client.id), thingId: String(this.item.id) },
      });
    }
  }

  goCatalog() {
    if (this.client && this.client.id != null && this.item && this.item.id != null) {
      this.$router.push({
        name: 'ai-looks-by-client-thing-from-catalog-things',
        params: { clientId: String(this.client.id), thingId: String(this.item.id) },
      });
    }
  }
}
